export enum NavLinkVariantsEnum {
  PRIMARY = "primary",
  SECONDARY= "secondary",
  TERTIARY = "tertiary"
};